import {
    allDayItemTemplate,
    blankItemTemplate,
    CalendarSurfaceStore,
    freeBusyTemplate,
    inDayItemTemplate,
    SurfaceItemTemplate,
} from 'owa-calendar-surface-dategrid';
import { CalendarEvent, renderAsAllDay } from 'owa-calendar-types';
import { getCalendarEventColorScheme } from 'owa-calendar-color-resolver';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getCharm } from 'owa-calendar-events-store';

import templateStyles from 'owa-calendar-surface-dategrid/lib/Templates.scss';

export const getDayGridStandardItemTemplate = (
    generateColorScheme: (model: CalendarEvent) => ColorScheme,
    joinButtonVisible: boolean,
    shouldHideTooltip?: () => boolean
): SurfaceItemTemplate => {
    return (viewState: CalendarSurfaceStore, model: CalendarEvent, state?: any) => {
        const templateFunc = renderAsAllDay(model)
            ? dayGridAllDayItemTemplate
            : dayGridInDayItemTemplate;
        return templateFunc(
            viewState,
            model,
            generateColorScheme(model),
            state,
            joinButtonVisible,
            shouldHideTooltip
        );
    };
};

const dayGridAllDayItemTemplate = (
    viewState: CalendarSurfaceStore,
    model: CalendarEvent,
    colorScheme: ColorScheme,
    itemState?: any,
    joinButtonVisible?: boolean,
    shouldHideTooltip?: () => boolean
): JSX.Element => {
    return allDayItemTemplate(
        viewState,
        model,
        colorScheme,
        getCharm(model),
        itemState,
        false /* increaseFontSize */,
        joinButtonVisible,
        shouldHideTooltip
    );
};

const dayGridInDayItemTemplate = (
    viewState: CalendarSurfaceStore,
    model: CalendarEvent,
    colorScheme: ColorScheme,
    state?: any,
    joinButtonVisible?: boolean,
    shouldHideTooltip?: () => boolean
): JSX.Element => {
    return inDayItemTemplate(
        viewState,
        model,
        colorScheme,
        getCharm(model),
        state,
        false /* increaseFontSize */,
        joinButtonVisible,
        shouldHideTooltip
    );
};

export const dayGridBlankItemTemplate = (
    viewState: CalendarSurfaceStore,
    model: CalendarEvent,
    itemState?: any
): JSX.Element => {
    return blankItemTemplate(viewState, model, getCalendarEventColorScheme(model), itemState);
};

export const dayGridFreeBusyTemplate = (model: CalendarEvent) => {
    return freeBusyTemplate(
        model.ItemId.Id,
        templateStyles.freeBusyColumnShadow,
        getCalendarEventColorScheme(model)
    );
};
